// The boat's Neo chat as a full page (TOM-195): `neo` opens the main chat
// (the boat's index was the chat until home took it, TOM-510, ADR 0335), and
// `neo/:conversationId` opens a chat from the Chats page.
//
// New chat opens `neo/new`, a separate chat; the main chat stays as it is
// (TOM-517, ADR 0337 §2). Once Neo first answers, the new chat takes its own
// address, `neo/:conversationId`. An old link to `neo?new=1` opens `neo/new`.

import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { NeoChatPage } from '../components/NeoChat';
import { newNeoChatPath } from '../lib/neoMainChat';
import { useDocumentTitle } from '../lib/useDocumentTitle';

/** The address a new chat has before Neo first answers it. */
const NEW_CHAT = 'new';

export function NeoPage() {
  const { boatId, conversationId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const oldNewLink = searchParams.get('new') === '1';
  useDocumentTitle('Neo — Neomaris');

  useEffect(() => {
    if (oldNewLink && boatId !== undefined) navigate(newNeoChatPath(boatId), { replace: true });
  }, [oldNewLink, boatId, navigate]);

  if (boatId === undefined || oldNewLink) return null;
  const fresh = conversationId === NEW_CHAT;
  return (
    <NeoChatPage
      key={boatId}
      boatId={boatId}
      conversationId={fresh ? undefined : conversationId}
      fresh={fresh}
    />
  );
}
